module.exports = __webpack_public_path__ + "img/tuto4.320b5db4.png";